export const EDIT_BUTTON_TITLE = 'Edit';
export const PAGE_TITLE = 'Triggered Message';
